// Client-side history of recent *content* search queries (strings the user
// actually searched for, not navigation/external/quick-action selections).
// Surfaced in the top-nav dropdown empty state. Stored in localStorage so it
// survives reloads; cleared on logout (see actions/logoutInternal.js).

const STORAGE_KEY = 'recentSearchQueries'

// Configurable cap on how many recent searches are kept / displayed.
export const RECENT_SEARCHES_LIMIT = 5

/**
 * Return the stored recent searches, newest first. Tolerates missing/corrupt
 * data by returning an empty array.
 */
export function getRecentSearches() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.filter((q) => typeof q === 'string')
  } catch (e) {
    return []
  }
}

/**
 * Record a query at the head of the recent-search list. Trims whitespace,
 * ignores empty strings, de-dupes case-insensitively (keeping the newest
 * casing), and caps the list at RECENT_SEARCHES_LIMIT.
 */
export function recordRecentSearch(query) {
  const trimmed = (query || '').trim()
  if (!trimmed) return getRecentSearches()
  const existing = getRecentSearches()
  const lower = trimmed.toLowerCase()
  const deduped = existing.filter((q) => q.toLowerCase() !== lower)
  const next = [trimmed, ...deduped].slice(0, RECENT_SEARCHES_LIMIT)
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch (e) {
    // Storage full / unavailable — non-fatal, just skip persisting.
  }
  return next
}

/**
 * Remove all stored recent searches.
 */
export function clearRecentSearches() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    // non-fatal
  }
}
